import React from 'react';
import { Grid, Typography } from '@mui/material';
import styles, { titleWithIconStyles } from './styles';

function Steps({ list = [] }) {
  return (
    <Grid container>
      {list.map((item, index) => (
        <Grid key={index} item xs={12} xl={2} sx={styles.item}>
          {item.title && (
            <Typography
              variant="desktopH5"
              sx={{ ...styles.title, ...titleWithIconStyles(item.icon) }}
            >
              {item.title}
            </Typography>
          )}
          {item.description && (
            <Typography variant="desktopP3" sx={styles.description}>
              {item.description}
            </Typography>
          )}
        </Grid>
      ))}
    </Grid>
  );
}

export default Steps;
